<template>
  <div class="reveive-feedcard">
    <img :src="imgUrl" alt="">
    <div
      :class="{
        'receive-btn': true,
        'disabled': loading || isReceive
      }"
      @click="receiveCard">立即领取
    </div>
  </div>
</template>

<script>
import { Indicator, MessageBox } from 'mint-ui'
import { FreeCardActivityGain } from '@/api/activity'
import { IMG_BASE_URL } from '@/config'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ReceiveFreeCard',
  data () {
    return {
      imgUrl: IMG_BASE_URL + '/upaiyun/Sys/20191218/4658827446061465978.jpg',
      loading: false,
      isReceive: false // 是否领取
    }
  },
  computed: {
    ...mapGetters([
      'loginState',
      'getIsApp',
      'getIsAuthorized'
    ])
  },
  methods: {
    ...mapMutations([
      'AUTHORIZE_POPUP_SHOW'
    ]),
    // 免单卡领取
    receiveCard () {
      if (!this.loginState) {
        this.unLoginModal()
        return
      }
      if (this.loading) return
      this.loading = true
      this.isReceive = false
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      FreeCardActivityGain().then(res => {
        Indicator.close()
        this.loading = false
        this.isReceive = true
        this.showMsgBox('免单卡领取成功，快前往0元专区看看吧', '0元专区', 'zeroBuyMain')
      }).catch(err => {
        Indicator.close()
        this.loading = false
        if (err.ErrMsg === '活动免单卡已领取了') {
          this.showMsgBox('免单卡已经领取了哦，请前往0元专区看看吧', '0元专区', 'zeroBuyMain')
        } else {
          this.showMsgBox(err.ErrMsg)
        }
      })
    },
    showMsgBox (msg, btnTxt = '我知道了', pathName = 'souhuo', escClose = false) {
      MessageBox({
        title: '提示',
        message: msg,
        closeOnPressEscape: escClose,
        closeOnClickModal: escClose,
        showCancelButton: false,
        confirmButtonText: btnTxt,
        confirmButtonClass: 't_f23030'
      }).then(action => {
        if (action === 'confirm') {
          this.$router.replace({
            name: pathName
          })
        }
      })
    },
    unLoginModal () {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    }
  }
}
</script>

<style scoped>
  .reveive-feedcard{
    position: relative;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background: #ffebb0;
    background: linear-gradient(#ffebb0, #fff2d1);
  }
  .reveive-feedcard img{
    display: block;
    width: 100%;
  }
  .receive-btn{
    position: absolute;
    left: 50%;
    top: 73.24%;
    width: 50%;
    height: 40px;
    transform: translateX(-50%);
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    background: #0b94da;
    color: #fff;
    font-size: 20px;
    letter-spacing: 2px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    z-index: 10;
  }
  .receive-btn:active{
    opacity: 0.8;
  }
  .receive-btn.disabled{
    opacity: 0.8;
    pointer-events: none;
  }
</style>
